import React, { createContext, useContext, useState } from 'react'
import Loader from '../CustomViews/Pages/Loader/Loader';

type LoadingScreenProps = {
    loading: boolean;
    setLoading: (loading: boolean) => void
}

export const LoadingScreenContext = createContext<LoadingScreenProps>({
    loading: false,
    setLoading: () => null,
})
export const useLoadingScreen = () => useContext(LoadingScreenContext)

export const LoadingScreenProvider = ({ children }: { children: React.ReactNode }) => {
    const [loading, setSLoading] = useState<boolean>(false);

    const setLoading = (isLoading: boolean) => {
        if((!isLoading) || (isLoading && !loading)) {
            setSLoading(isLoading);
        }
    }

    return (
        <LoadingScreenContext.Provider value={{ loading, setLoading }}>
            {loading && <Loader />}
            {children}
        </LoadingScreenContext.Provider>
    )
}